import React from 'react';

interface GradientTextProps {
  children: React.ReactNode;
  className?: string;
}

export function GradientText({ children, className = '' }: GradientTextProps) {
  // Nous allons permettre de passer une classe personnalisée pour le gradient,
  // mais nous fournissons toujours une valeur par défaut (notre nouveau gradient)
  const hasGradientClass = className.includes('bg-gradient-to-');
  
  const baseClasses = 'bg-clip-text text-transparent';
  const defaultGradient = 'bg-gradient-to-r from-violet-600 via-indigo-500 to-cyan-500';
  
  const combinedClasses = hasGradientClass
    ? `${baseClasses} ${className}`
    : `${baseClasses} ${defaultGradient} ${className}`;
    
  return (
    <span className={combinedClasses}>
      {children}
    </span>
  );
}